import React from 'react';
import { Link } from '@philips-internal/oswald-ui-components';
import { Size } from '@philips-internal/oswald-ui-constants';
import { AuthenticationService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
function LogoutLink(props) {
    const { logoutExpression } = props;
    const onLogoutClick = () => {
        void AuthenticationService.logout().then(() => {
            AuthenticationService.redirectToLogin();
        });
    };
    return (React.createElement(Link, { className: "c-spotlight__logout", onClick: onLogoutClick, size: Size.MEDIUM, value: logoutExpression }));
}
export { LogoutLink, };
//# sourceMappingURL=logout.js.map